const DATABASE_NAME = "mozzoapp-we-rider-local-documents";
const DATABASE_VERSION = 1;
const STORE_NAME = "identity_documents";

const canUseIndexedDb = () =>
  typeof window !== "undefined" && Boolean(window.indexedDB);

const openDatabase = () =>
  new Promise((resolve, reject) => {
    if (!canUseIndexedDb()) {
      resolve(null);
      return;
    }
    const request = window.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
    request.onerror = () => reject(request.error);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        const store = database.createObjectStore(STORE_NAME, { keyPath: "key" });
        store.createIndex("driver_id", "driverId", { unique: false });
      }
    };
    request.onsuccess = () => resolve(request.result);
  });

const waitForTransaction = (transaction) =>
  new Promise((resolve, reject) => {
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
    transaction.onabort = () => reject(transaction.error);
  });

export const saveLocalWeRiderIdentityDocuments = async (
  driverId,
  documents
) => {
  const database = await openDatabase();
  if (!database) return;
  try {
    const transaction = database.transaction(STORE_NAME, "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const index = store.index("driver_id");
    const existingKeysRequest = index.getAllKeys(driverId);
    existingKeysRequest.onsuccess = () => {
      existingKeysRequest.result.forEach((key) => store.delete(key));
      (Array.isArray(documents) ? documents : []).forEach(({ type, file }) => {
        store.put({
          key: `${driverId}:${type}`,
          driverId,
          type,
          file,
          updatedAt: new Date().toISOString(),
        });
      });
    };
    await waitForTransaction(transaction);
  } finally {
    database.close();
  }
};

export const loadLocalWeRiderIdentityDocuments = async (driverId) => {
  const database = await openDatabase();
  if (!database) return [];
  try {
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, "readonly");
      const request = transaction.objectStore(STORE_NAME).index("driver_id").getAll(driverId);
      request.onsuccess = () => resolve(request.result || []);
      request.onerror = () => reject(request.error);
    });
  } finally {
    database.close();
  }
};

export const clearLocalWeRiderIdentityDocuments = async () => {
  const database = await openDatabase();
  if (!database) return;
  try {
    const transaction = database.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).clear();
    await waitForTransaction(transaction);
  } finally {
    database.close();
  }
};
